/**
 * Renderer for the Series `id` column.
 *
 * Renders a link when `showLink` is present, otherwise plain text.
 * Mirrors the Kendo `idTemplate` behavior from the legacy index.jsx.
 */
import React from 'react';
export function SeriesIdRenderer({ item }) {
    if (!item.id) {
        return React.createElement("span", null, "-");
    }
    if (item.showLink) {
        return (React.createElement("a", { href: item.showLink, className: "--primary-link" }, item.id));
    }
    return React.createElement("span", null, item.id);
}
